// Chart configurations for ApexCharts
// Only includes actively used chart configs

// Helper function for dynamic month labels
const getLast12MonthLabels = () => {
  const now = new Date();
  const labels: string[] = [];

  for (let i = 11; i >= 0; i--) {
    const date = new Date(now.getFullYear(), now.getMonth() - i);
    const label = date.toLocaleString("default", { month: "short" }).toUpperCase();
    labels.push(label);
  }

  return labels;
};

// Sidebar Chart
export const lineChartDataSidebar = [
  { name: "Balance", data: [10, 39, 80, 50, 10] },
  { name: "Profit", data: [20, 60, 30, 40, 20] },
];

export const lineChartOptionsSidebar = {
  chart: {
    toolbar: { show: false },
  },
  markers: {
    size: 0,
    colors: "#868CFF",
    strokeColors: "white",
    strokeWidth: 2,
    strokeOpacity: 0.9,
    strokeDashArray: 0,
    fillOpacity: 1,
    shape: "circle",
    radius: 2,
    offsetX: 0,
    offsetY: 0,
    showNullDataPoints: true,
  },
  tooltip: { theme: "dark" },
  dataLabels: { enabled: false },
  stroke: { curve: "smooth", type: "gradient" },
  xaxis: {
    categories: ["Sat", "Sun", "Mon", "Tue", "Wed"],
    labels: {
      style: { colors: "white", fontSize: "12px", fontWeight: "500" },
    },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: { show: false },
  legend: { show: false },
  grid: {
    show: false,
    column: { colors: ["transparent"], opacity: 0.5 },
  },
  fill: {
    type: "gradient",
    gradient: {
      type: "vertical",
      shadeIntensity: 0.1,
      opacityFrom: 0.3,
      opacityTo: 0.9,
      colorStops: [
        [
          { offset: 0, color: "white", opacity: 1 },
          { offset: 100, color: "white", opacity: 0 },
        ],
        [
          { offset: 0, color: "#6AD2FF", opacity: 1 },
          { offset: 100, color: "#6AD2FF", opacity: 0.2 },
        ],
      ],
    },
  },
};

// Overall Revenue Chart (Connections component)
export const lineChartOptionsOverallRevenue = {
  chart: {
    toolbar: { show: false },
    dropShadow: {
      enabled: true,
      top: 13,
      left: 0,
      blur: 10,
      opacity: 0.1,
      color: "var(--color-500)",
    },
  },
  colors: ["var(--color-500)", "#39B8FF"],
  markers: {
    size: 0,
    colors: "white",
    strokeColors: "#7551FF",
    strokeWidth: 3,
    strokeOpacity: 0.9,
    strokeDashArray: 0,
    fillOpacity: 1,
    shape: "circle",
    radius: 2,
    offsetX: 0,
    offsetY: 0,
    showNullDataPoints: true,
  },
  tooltip: { theme: "dark" },
  dataLabels: { enabled: false },
  stroke: { curve: "smooth", type: "line" },
  xaxis: {
    type: "numeric",
    categories: getLast12MonthLabels(),
    labels: {
      style: { colors: "#A3AED0", fontSize: "12px", fontWeight: "500" },
    },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: { show: false },
  legend: { show: false },
  grid: {
    show: false,
    column: { color: ["#7551FF", "#39B8FF"], opacity: 0.5 },
  },
  color: ["#7551FF", "#39B8FF"],
};

// Daily Traffic Bar Chart (Discovery component)
export const barChartOptionsDailyTraffic = (categories: string[]) => ({
  chart: {
    toolbar: { show: false },
  },
  tooltip: {
    style: { fontSize: "12px" },
    onDatasetHover: { style: { fontSize: "12px" } },
    theme: "dark",
  },
  xaxis: {
    categories: categories,
    show: false,
    labels: {
      show: true,
      style: { colors: "#A3AED0", fontSize: "14px", fontWeight: "500" },
    },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: {
    show: false,
    color: "black",
    labels: {
      show: true,
      style: { colors: "#CBD5E0", fontSize: "14px" },
    },
  },
  grid: {
    show: false,
    strokeDashArray: 5,
    yaxis: { lines: { show: true } },
    xaxis: { lines: { show: false } },
  },
  fill: {
    type: "gradient",
    gradient: {
      type: "vertical",
      shadeIntensity: 1,
      opacityFrom: 0.7,
      opacityTo: 0.9,
      colorStops: [
        [
          { offset: 0, color: "var(--color-500)", opacity: 1 },
          { offset: 100, color: "rgba(255, 255, 255, 1)", opacity: 0.0 },
        ],
      ],
    },
  },
  dataLabels: { enabled: false },
  plotOptions: {
    bar: { borderRadius: 10, columnWidth: "40px" },
  },
});

// Project Status Line Chart (UserStats component)
export const lineChartOptionsProjectStatus = {
  chart: {
    toolbar: { show: false },
    dropShadow: {
      enabled: true,
      top: 13,
      left: 0,
      blur: 10,
      opacity: 0.1,
      color: "var(--color-500)",
    },
  },
  colors: ["var(--color-500)", "#39B8FF", "#10B981"],
  markers: {
    size: 0,
    colors: "white",
    strokeColors: "var(--color-500)",
    strokeWidth: 2,
    strokeOpacity: 0.9,
    strokeDashArray: 0,
    fillOpacity: 1,
    shape: "circle",
    radius: 2,
    offsetX: 0,
    offsetY: 0,
    showNullDataPoints: true,
  },
  tooltip: { theme: "dark" },
  dataLabels: { enabled: false },
  stroke: { curve: "smooth", type: "gradient" },
  xaxis: {
    categories: getLast12MonthLabels(),
    labels: {
      style: { colors: "#A3AED0", fontSize: "14px", fontWeight: "500" },
    },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: { show: false },
  legend: { show: false },
  dropShadow: {
    enabled: true,
    top: 0,
    left: 0,
    blur: 3,
    opacity: 0.5,
  },
  grid: {
    show: false,
    column: { colors: ["transparent"], opacity: 0.5 },
  },
};
